import { GenericPage } from "../components/common/GenericPage";
import {
  starshipsCollapseTableFields,
  starshipsTableFields,
} from "../utils/table-fields/starshipsTableFields";

export const AllStarships = () => {
  return (
    <GenericPage
      title="All Starships"
      subtitle="Technical specifications of interstellar craft"
      parentQuery="allStarships"
      childQuery="starships"
      tableFields={starshipsTableFields}
      collapseFields={starshipsCollapseTableFields}
    />
  );
};
